import qaConfig from './log.qa';
export default qaConfig;
